import { useTranslation } from 'react-i18next';
import { Button } from '../../ui/Button';
import { Dialog } from '../../ui/Dialog';

/** Asked before leaving a board whose edits are not all sent yet (P16, backlog §19); "Stay" is the default. */
export function LeaveBoard({ onStay, onLeave }: { onStay: () => void; onLeave: () => void }) {
  const { t } = useTranslation();
  return (
    <Dialog
      title={t('leaveBoard.title')}
      description={t('leaveBoard.body')}
      onClose={onStay}
      footer={
        <>
          <Button variant="secondary" onClick={onLeave}>
            {t('leaveBoard.leave')}
          </Button>
          <Button variant="primary" autoFocus onClick={onStay}>
            {t('leaveBoard.stay')}
          </Button>
        </>
      }
    />
  );
}
